/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { MeasValueType } from './MeasValueType';
import {
    MeasValueTypeFromJSON,
    MeasValueTypeFromJSONTyped,
    MeasValueTypeToJSON,
} from './MeasValueType';
import type { SequenceSubType } from './SequenceSubType';
import {
    SequenceSubTypeFromJSON,
    SequenceSubTypeFromJSONTyped,
    SequenceSubTypeToJSON,
} from './SequenceSubType';

/**
 * 
 * @export
 * @interface TrackItDataSequenceValuesDto
 */
export interface TrackItDataSequenceValuesDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceValuesDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceValuesDto
     */
    measurementId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceValuesDto
     */
    parentSequenceId?: number | null;
    /**
     * 
     * @type {MeasValueType}
     * @memberof TrackItDataSequenceValuesDto
     */
    measurementType?: MeasValueType;
    /**
     * 
     * @type {SequenceSubType}
     * @memberof TrackItDataSequenceValuesDto
     */
    sequencePartType?: SequenceSubType;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceValuesDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceValuesDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItDataSequenceValuesDto
     */
    pointCount?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TrackItDataSequenceValuesDto
     */
    values?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItDataSequenceValuesDto
     */
    $type?: TrackItDataSequenceValuesDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItDataSequenceValuesDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItDataSequenceValuesDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItDataSequenceValuesDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItDataSequenceValuesDtoTypeEnum = typeof TrackItDataSequenceValuesDtoTypeEnum[keyof typeof TrackItDataSequenceValuesDtoTypeEnum];



/**
 * Check if a given object implements the TrackItDataSequenceValuesDto interface.
 */
export function instanceOfTrackItDataSequenceValuesDto(value?: unknown): value is TrackItDataSequenceValuesDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItDataSequenceValuesDtoTypeEnum)[0];
}

export function TrackItDataSequenceValuesDtoFromJSON(json: any): TrackItDataSequenceValuesDto {
    return TrackItDataSequenceValuesDtoFromJSONTyped(json, false);
}

export function TrackItDataSequenceValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataSequenceValuesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'measurementId': json['measurementId'] == null ? undefined : json['measurementId'],
        'parentSequenceId': json['parentSequenceId'] == null ? undefined : json['parentSequenceId'],
        'measurementType': json['measurementType'] == null ? undefined : MeasValueTypeFromJSON(json['measurementType']),
        'sequencePartType': json['sequencePartType'] == null ? undefined : SequenceSubTypeFromJSON(json['sequencePartType']),
        'name': json['name'] == null ? undefined : json['name'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'pointCount': json['pointCount'] == null ? undefined : json['pointCount'],
        'values': json['values'] == null ? undefined : json['values'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItDataSequenceValuesDtoToJSON(value?: TrackItDataSequenceValuesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'measurementId': value['measurementId'],
        'parentSequenceId': value['parentSequenceId'],
        'measurementType': MeasValueTypeToJSON(value['measurementType']),
        'sequencePartType': SequenceSubTypeToJSON(value['sequencePartType']),
        'name': value['name'],
        'unit': value['unit'],
        'pointCount': value['pointCount'],
        'values': value['values'],
        '$type': value['$type'],
    });
}

